import type {
  AlloyLegacyThemeDesignTokens,
  DividerDesignTokens,
} from '../types';
import { Weave3DividerInput } from '../types/weave3Types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

export const getDividerTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): DividerDesignTokens => ({
  color: {
    subtle: theme.tokens.colors.border.subtler.value,
    default: theme.tokens.colors.border.subtle.value,
    strong: theme.tokens.colors.border.value,
  },
});

export const getDividerTokensWeave = (
  tokens: WeaveTokens,
): DividerDesignTokens => ({
  ...tokens?.component?.divider,
  color: {
    subtle: tokens?.semantic?.['border-color']?.divider?.light,
    default: tokens?.semantic?.['border-color']?.divider?.light,
    strong: tokens?.semantic?.['border-color']?.divider?.heavy,
  },
});

export const getDividerTokensWeave3 = (
  divider?: Weave3DividerInput,
): DividerDesignTokens => ({
  color: {
    subtle: divider?.subtle?.['border-color'],
    default: divider?.default?.['border-color'],
    strong: divider?.dark?.['border-color'],
  },
});
